import { __decorate } from "tslib";
import colors from '@/styles/color.scss';
import lang from '@blade-sxp/portrait-management/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { PageQueryTypeEnum, VehicleTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { Scale } from '@blade/common/utils/auto-scale';
import { deleteAutomobileRelation } from '@blade-sxp/portrait-management/api/vehicle';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { SYSTEMCODE } from '@blade/common/constants/code';
import { PortraitManagementDataModule } from '@blade-sxp/portrait-management/store/index';
const Webapi = {
    deleteAutomobileRelation,
};
let default_1 = class default_1 extends Vue {
    data;
    loading;
    pagination;
    refresh;
    // 权限级别
    permissionlevel = permissionlevel;
    systemCode = SYSTEMCODE;
    defaultPageSize = [10, 20, 50, 100, 200];
    defaultTableMinWidth = {
        selection: 48 * Scale,
        picture: 88 * Scale,
        plateNumber: 129 * Scale,
        brand: 110 * Scale,
        type: 110 * Scale,
        color: 100 * Scale,
        vehicleLibrary: 134 * Scale,
        ownerName: 146 * Scale,
        ownerId: 151 * Scale,
        action: 104 * Scale,
    };
    PortraitManagementDataModule = PortraitManagementDataModule;
    VehicleTypeEnum = VehicleTypeEnum;
    /** 模糊尺寸 */
    get blurSize() {
        return this.privacyMode ? 6 : 0;
    }
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    /** 照片最大宽度 */
    get pictureMaxWidth() {
        return 240 * Scale;
    }
    /** 照片最大高度 */
    get pictureMaxHeight() {
        return 240 * Scale;
    }
    cellBackground = colors.colorBoxBg;
    // 提交中
    submiting = false;
    handleSizeChange(val) {
        this.pagination.size = val;
        this.$emit('update:pagination', this.pagination);
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.$emit('update:pagination', this.pagination);
    }
    handleSelectionChange(val) {
        this.$emit('selection', val);
    }
    goDetail(item) {
        const query = this.$route.query;
        this.$router.push({ name: 'vehicleCreate', query: { ...query, type: PageQueryTypeEnum.DETAIL, id: item.automobileId.toString() } });
    }
    handleEdit(item) {
        const query = this.$route.query;
        this.$router.push({ name: 'vehicleCreate', query: { ...query, type: PageQueryTypeEnum.EDIT, id: item.automobileId.toString() } });
    }
    async deleteAutomobileRelation(relationId) {
        try {
            this.$emit('update:loading', true);
            await Webapi.deleteAutomobileRelation({
                relationId,
            });
            this.$message({
                customClass: 'success-message',
                message: this.$t('deletedSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.handleCurrentChange(1);
            this.refresh();
        }
        catch (error) {
            this.$emit('update:loading', false);
        }
    }
    handleDelete(item) {
        if (this.loading)
            return;
        this.$elconfirm(`${this.$t('deleteVehicleTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.deleteAutomobileRelation(item.relationId);
                }
            },
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
default_1 = __decorate([
    Component({
        i18n: { messages: lang },
        components: { BlurPicture, CombinedPicture, AuthNewitem },
    })
], default_1);
export default default_1;
